setUserProfileImagesProcessing